import { render, staticRenderFns } from "./FormaPagamentoList.vue?vue&type=template&id=ec7ede4c"
import script from "./FormaPagamentoList.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports